import { render, staticRenderFns } from "./cms-component.vue?vue&type=template&id=5311d461&scoped=true"
import script from "./cms-component.vue?vue&type=script&lang=js"
export * from "./cms-component.vue?vue&type=script&lang=js"
import style0 from "./cms-component.vue?vue&type=style&index=0&id=5311d461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311d461",
  null
  
)

export default component.exports